import $ from 'jquery';
import 'sylius/ui-resources/js/sylius-require-confirmation';
import AjaxContent from '../components/ajax-content';
import { ConfirmLinkModal } from '../components/confirm-link-modal';
import { CheckboxTreeSync } from '../components/checkbox-tree-sync';
const AjaxLoadCustomerMenus = (() => {
    const domStr = {
        customerShowInfoTab: '.js__show-customer-info-tab',
        customerShowOrderTab: '.js__show-order-tab',
        customerShowDeviceTab: '.js__show-device-tab',
        customerShowActionLogTab: '.js__show-action-log-tab',
        customerShowAgeVerificationLogTab: '.js__show-age-verification-log-tab',
        customerShowPointTransactionLogTab: '.js__show-point-transaction-log-tab',
        customerShowEmailLogTab: '.js__show-email-log-tab',
        ageVerificationLogTableContainer: '.age-verification-log-container',
        pointTransactionLogTableContainer: '.point-transaction-log-container',
        emailLogTableContainer: '.email-log-container',
        customerShowSegmentsTab: '.js__show-segments-tab',
        customerShowCommentsTab: '.js__show-comments-tab',
        customerShowTalkingPointsTab: '.js__show-talking-points-log-tab',
        customerShowCommunicationHistoryTab: '.js__show-communication-history-tab',
        customerInfoContainer: '.customer-info-container',
        orderTableContainer: '.orders-container',
        deviceTableContainer: '.device-container',
        actionLogTableContainer: '.action-log-container',
        segmentsTableContainer: '.segments-container',
        commentsTableContainer: '.comments-container',
        talkingPointsTableContainer: '.talking-points-container',
        communicationHistoryTableContainer: '.communication-history-container',
        customerMenuTabs: '.customer-menu .item',
        customerActionsDropdownBtn: '.actions-dropdown',
        unassignedBtn: '.device-unassign-btn',
        removeSegmentBtn: '.js__remove-segment-btn',
        confirmModal: '.conform-modal',
        body: 'body',
        confirmUnassignedDeviceBtn: '.confirm-unassign-device',
        confirmRemoveSegmentBtn: '.confirm-remove-segment',
        paginationPageBtn: '.js__ajax-customer-menu-pagination .item',
        paginationContainer: '.js__ajax-customer-menu-pagination-container',
        mfaBypassLinkLogTab: '.js__show-mfa-bypass-log-tab',
        mfaBypassLinkLogContainer: '.mfa-bypass-link-log-container',
        orderSyncFromSapLogsTab: '.js__ajax-order-sync-from-sap-logs-tab',
        orderSyncFromSapLogsContainer: '.order-sync-from-sap-logs-container',
    };
    const loader = '<div class="ui text loader">Loading</div>';
    let isLoading = false;
    const requestStack = {};
    const makeDataCall = (url) => {
        requestStack[url] = true;
        return $.when($.get(url));
    };
    const addLoader = (element) => {
        $(element).addClass('dimmer');
        $(element).html(loader);
    };
    const displayContent = (element, html) => {
        $(element).removeClass('dimmer');
        $(element).html(html);
    };
    const addDomElements = (element, $self, url = '') => {
        if (!isLoading) {
            isLoading = true;
            $(domStr.customerMenuTabs).addClass('disabled isDisabled');
            addLoader(element);
            makeDataCall(url || $self?.data('url')).done(res => {
                displayContent(element, res);
                $(domStr.customerMenuTabs).removeClass('disabled isDisabled');
                $(domStr.customerActionsDropdownBtn).dropdown();
                // @ts-ignore
                $('[data-requires-confirmation]').requireConfirmation();
                CheckboxTreeSync.init($(element));
                isLoading = false;
                AjaxContent.init($(element));
                ConfirmLinkModal.init($(element));
            });
        }
    };
    const refreshTabContent = (url, element, tab) => {
        if (!requestStack[url]) {
            $(domStr.confirmModal).modal('hide');
            addLoader(element);
            makeDataCall(url).then(() => {
                requestStack[url] = false;
                addDomElements(element, $(tab));
            });
        }
    };
    const callConfirmModal = (id) => {
        const $modal = $(`${domStr.confirmModal}[data-id="${id}"]`).first();
        // @ts-ignore
        $modal.modal('setting', 'closable', false).modal('show');
    };
    const setupEventListeners = () => {
        $(domStr.customerShowInfoTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.customerInfoContainer, $tab);
            }
        });
        $(domStr.customerShowOrderTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.orderTableContainer, $tab);
            }
        });
        $(domStr.customerShowDeviceTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.deviceTableContainer, $tab);
            }
        });
        $(domStr.customerShowActionLogTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.actionLogTableContainer, $tab);
            }
        });
        $(domStr.customerShowAgeVerificationLogTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.ageVerificationLogTableContainer, $tab);
            }
        });
        $(domStr.customerShowPointTransactionLogTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.pointTransactionLogTableContainer, $tab);
            }
        });
        $(domStr.customerShowEmailLogTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.emailLogTableContainer, $tab);
            }
        });
        $(domStr.customerShowSegmentsTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.segmentsTableContainer, $tab);
            }
        });
        $(domStr.customerShowCommentsTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.commentsTableContainer, $tab);
            }
        });
        $(domStr.customerShowTalkingPointsTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.talkingPointsTableContainer, $tab);
            }
        });
        $(domStr.customerShowCommunicationHistoryTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.communicationHistoryTableContainer, $tab);
            }
        });
        $(domStr.body).on('click', domStr.unassignedBtn, e => {
            const $button = $(e.currentTarget);
            callConfirmModal($button.data('id'));
        });
        $(domStr.body).on('click', domStr.confirmUnassignedDeviceBtn, e => {
            const $button = $(e.currentTarget);
            refreshTabContent($button.data('url'), domStr.deviceTableContainer, domStr.customerShowDeviceTab);
        });
        $(domStr.body).on('click', domStr.removeSegmentBtn, e => {
            const $button = $(e.currentTarget);
            callConfirmModal($button.data('id'));
        });
        $(domStr.body).on('click', domStr.confirmRemoveSegmentBtn, e => {
            const $button = $(e.currentTarget);
            refreshTabContent($button.data('url'), domStr.segmentsTableContainer, domStr.customerShowSegmentsTab);
        });
        $(domStr.body).on('click', domStr.paginationPageBtn, e => {
            e.preventDefault();
            const $button = $(e.currentTarget);
            addDomElements($button.closest(domStr.paginationContainer), null, $button.attr('href'));
        });
        $(domStr.mfaBypassLinkLogTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.mfaBypassLinkLogContainer, $tab);
            }
        });
        $(domStr.mfaBypassLinkLogTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.mfaBypassLinkLogContainer, $tab);
            }
        });
        $(domStr.orderSyncFromSapLogsTab).on('click', e => {
            const $tab = $(e.currentTarget);
            if (!$tab.hasClass('active')) {
                addDomElements(domStr.orderSyncFromSapLogsContainer, $tab);
            }
        });
    };
    return {
        init() {
            setupEventListeners();
        },
        addDomElements,
    };
})();
export default AjaxLoadCustomerMenus;
